//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiDotsVertical, mdiArrowRight } from '@mdi/js'

export default {
  setup() {
    const paymentDetails = [
      {
        avatarImg: require('@/assets/images/logos/master-card.jpg'),
        title: 'Credit card',
        cardNo: '2566 xxxx xxxx 8908',
      },
      {
        avatarImg: require('@/assets/images/logos/credit-card2.jpg'),
        title: 'Credit card',
        cardNo: '8990 xxxx xxxx 6852',
      },
    ]

    return {
      paymentDetails,
      icons: {
        mdiDotsVertical,
        mdiArrowRight,
      },
    }
  },
}
